"use client";

const linkClass =
  "pointer-events-auto -translate-y-full rounded-md border border-dark-border bg-mot-black px-3 py-2 text-sm font-medium text-mot-white shadow-lg outline-none transition-transform focus:translate-y-0 focus:ring-2 focus:ring-mot-teal focus:ring-offset-2 focus:ring-offset-mot-black";

function focusTarget(id: "main-content" | "site-navigation") {
  return (event: React.MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    target.focus();
  };
}

/**
 * First keyboard-focusable content: jump to the main landmark or site nav.
 * Hidden off-screen until focused.
 */
export function SkipLinks() {
  return (
    <nav
      className="pointer-events-none fixed left-0 top-0 z-[100] flex flex-wrap gap-2 p-2"
      aria-label="Skip links"
    >
      <a href="#main-content" className={linkClass} onClick={focusTarget("main-content")}>
        Skip to main content
      </a>
      <a href="#site-navigation" className={linkClass} onClick={focusTarget("site-navigation")}>
        Skip to navigation
      </a>
    </nav>
  );
}
